export default "__VITE_ASSET__4rqlEBME__"